import produce from 'immer';
import {
  RESETSTATSLOG_LIST_REQUEST,
} from '../../constants/log/resetStatsLogConstants';

const initialState = {

};

const resetStatsLogReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case RESETSTATSLOG_LIST_REQUEST:
      break;
    default:
      break;
  }
});

export default resetStatsLogReducer;
